import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const InfoMainContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: ${({ justifyContent }) =>
        justifyContent ? justifyContent : 'space-between'};
    height: 100%;
`;

export const InfoItems = styled.div`
    width: 50%;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin-bottom: ${({ setMarginBottom }) =>
        setMarginBottom ? '16px' : '0px'};

    ${media.mobileDevice`
        width: 100%;
    `}
`;

export const InfoItemsTitle = styled.div`
    font-family: AvenirNextWorld demi;
    color: #202124;
    font-size: 14px;
    margin-bottom: 8px;
`;

export const InfoItemsValue = styled.div`
    font-family: AvenirNextWorld Regular;
    color: #202124;
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '16px')};
    margin-bottom: ${({ marginBottom }) =>
        marginBottom ? marginBottom : '7px'};
    padding: ${({ padding }) => (padding ? padding : '')};
    ${media.mobileDevice`
        margin-bottom: 0px;
    `}
`;
